import loadable from '@loadable/component'

export default {
    '/:type/news': loadable(() => import('./List')),
    '/:type/news/tag/:tagId': loadable(() => import('./tag')),
    '/:type/news/:news_id': loadable(() => import('./Details'))
}